module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "wac.92a80da2.svg";